import { render, staticRenderFns } from "./SuggestMember.vue?vue&type=template&id=5b0c0594&scoped=true&"
import script from "./SuggestMember.vue?vue&type=script&lang=ts&"
export * from "./SuggestMember.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestMember.vue?vue&type=style&index=0&id=5b0c0594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0c0594",
  null
  
)

export default component.exports